module.exports = __webpack_public_path__ + "img/ice-potolok.5f7a2617.png";